import React, { useContext, useMemo, useState } from "react";
import AllStateContext from "../context/allstateContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { formatDateMonthYear } from "./Common";
import { createBudget, updateBudget } from "../components/Apis/apis";
import { API_RESP_STATUS } from "../Constant/constant";

const AddNewBudgetDialog = ({ refetch }) => {
  const {
    selectedDate,
    setSelectedDate,
    addNewBudgetDialog,
    setAddNewBudgetDialog,
    selectedBudgetItem,
    startEndDate,
    setSelectedBudgetItem,
  } = useContext(AllStateContext);
  const [limit, setLimit] = useState("");

  const handleClose = () => {
    setSelectedBudgetItem("");
    setAddNewBudgetDialog(false);
  };
  useMemo(() => {
    if (selectedBudgetItem?.budgetDetail != null) {
      setLimit(selectedBudgetItem.budgetDetail.limit);
    }
  }, [selectedBudgetItem]);
  const handelAmountNotes = (e) => {
    const { value } = e.target;
    setLimit(value);
  };
  const handleSave = async () => {
    console.log("limit", limit);
    if (!limit) {
      alert("Limit is required ...!");
    } else {
      try {
        let response;
        if (selectedBudgetItem?.budgetDetail == null) {
          const body = {
            categoryId: selectedBudgetItem.categoryId,
            limit: limit,
            month: formatDateMonthYear(startEndDate.startDate),
          };
          response = await createBudget(body);
        } else {
          const body = {
            categoryId: selectedBudgetItem.categoryId,
            limit: limit,
            month: formatDateMonthYear(startEndDate.startDate),
          };
          response = await updateBudget(
            { budgetId: selectedBudgetItem.budgetDetail.budgetId },
            body
          );
        }
        if (response.data.status == API_RESP_STATUS.success) {
          setLimit("");
          refetch();
          setAddNewBudgetDialog(false);
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={addNewBudgetDialog}
        onClose={handleClose}
      >
        <DialogTitle>Set Budget</DialogTitle>
        <DialogContent>
          <div className="d-flex align-items-center gap-3 mb-4 p-3 rounded-3" style={{ background: "rgba(255, 255, 255, 0.02)", border: "1px solid rgba(255, 255, 255, 0.05)" }}>
            <img
              style={{ width: "36px", height: "36px", borderRadius: "8px" }}
              src={selectedBudgetItem.iconDetail.icon}
              alt={selectedBudgetItem.name}
            />
            <div>
              <div style={{ fontSize: "0.8rem", color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: "0.05em" }}>Category</div>
              <div style={{ fontWeight: "700", fontSize: "1.1rem" }}>{selectedBudgetItem.name}</div>
            </div>
          </div>

          <div className="form-floating mb-3">
            <input
              name="limit"
              type="number"
              onChange={handelAmountNotes}
              value={limit}
              className="form-control"
              placeholder=" "
              id="budgetLimit"
              required
            />
            <label htmlFor="budgetLimit">Limit Amount</label>
          </div>
          
          <div className="p-3 rounded-3 mb-1 text-center" style={{ background: "rgba(99, 102, 241, 0.03)", border: "1px dashed rgba(99, 102, 241, 0.2)", color: "var(--primary)", fontWeight: "600", fontSize: "0.9rem" }}>
            Target Period: {formatDateMonthYear(startEndDate.startDate)}
          </div>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            Save Budget
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddNewBudgetDialog;
